import { createFileRoute } from '@tanstack/react-router';

import { PlanPage, validatePlanSearch } from '../../features/shipment-plan';

export const Route = createFileRoute('/_app/plan')({
  staticData: { crumbs: ['План отгрузок'] },
  validateSearch: validatePlanSearch,
  component: PlanPage,
});
